// @ts-nocheck
import React from 'react';
import icons from '../../../../constants/icons';
import { skuNameSubsition } from '../../../../util/formatter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface SKURowProps {
  game: Record<string, unknown>;
  style: React.CSSProperties;
  onRemove: (game: unknown) => void;
}

function SKURow({ game, style, onRemove }: SKURowProps) {
  return (
    <div className="grid-game-name bulk-grid-sku-name" style={style}>
      {game.showRemove && (
        <button
          className="btn btn-default btn--square btn-outline"
          onClick={() => onRemove(game)}
        >
          <FontAwesomeIcon icon={icons.DELETE_TAG} />
        </button>
      )}
      {skuNameSubsition(game.gameName, game.name)}
    </div>
  );
}

export default SKURow;
